<template>
  <div>
    <div @click="details(item)" class="card-box" v-for="(item, index) in dataInfo" :key="index">
      <div class="card-title">{{ item.title }}</div>
      <div class="time">{{ item.time }}</div>
      <div class="content" v-html="item.content"></div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        dataInfo: {
        type: Array,
        default: function () {
            return [
                {
                title: '2025世界人形机器人运动会面向全球公开征集赛事口号',
                time: '2025-05-25',
                content: '2025世界人形机器人运动会（以下简称"机器人运动会"）将于8月15日在中国北京举行。本届运动会致力于推动机器人产业蓬勃发展与技术迭代升级，让机器人更快更好地走进人类生活，服务…'
                }
            ]
        }
    }
    },
    created() {
    },
    mounted() {
    },
    data() {
        return { }
    },
    methods: {
        details(item) {
            localStorage.setItem('dataInfo', JSON.stringify(item))
            this.$router.push({ path: 'content' })
        }
    },
    computed: {},
    watch: {},
    filters: {},
    components: {}
}
</script>

<style lang="scss" scoped>
.card-box{
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(222,229,243,0.3);
    border-radius: 10px;
    padding: 12px 20px;
    margin-bottom: 10px;
    .card-title{
        font-family: PingFangSC, PingFang SC;
        font-weight: 800;
        font-size: 16px;
        color: #334694;
        line-height: 22px;
        text-align: left;
        font-style: normal;
    }
    .time{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #AAAAAA;
        line-height: 17px;
        text-align: left;
        font-style: normal;
        border-bottom: 1px solid #F1F1F1;
        padding: 8px 0;
    }
    .content{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        padding-top: 8px;
        word-break: break-all;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 4;
		overflow: hidden;
    }
}
</style>
